
    <template>
        <div class="path-chart wrapper col-md-12">
            <div class="col-lg-7 chart">
                <canvas ref="chart" class="chart-canvas" style=""></canvas>
            </div>
            <div ref="legend" class="legend col-lg-5"></div>
        </div>

    </template>

<script>
    import Chart from 'chart.js';
    import _ from 'underscore';

    export default {
        props: ['data'],
        mounted() {
            let data = this.data[0];
            let labels = [];
            let values = [];

            data = Object.keys(data).map(function (key) { return data[key]; })
            .filter(function(d) { return d != ''})
            .sort(function(a, b) {
                return parseInt(b.value) - parseInt(a.value);
            })
            .slice(0,7);


            labels = data.map(function(d) { return d.label });
            values = data.map(function(d) { return d.value });    


            var ctx = this.$refs.chart.getContext('2d');

            var roleChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                            backgroundColor: ['#e470a4', '#ff7a83', '#df784d', '#ffa66b', '#91a652', '#549c52', '#48836c'],
                            data: values,
                            borderWidth:3,
                            borderColor:'#444'
                    }]
                },
                options: {
                    responsive:true,
                    maintainAspectRatio:false,
                    legend: {
                        display: false
                    }
                }
            });

            this.$refs.legend.innerHTML = roleChart.generateLegend();
        }
    }

</script>

<style lang="scss">
    .chart-canvas {
        max-width:100%;
        height:220px!important;
        width:640px!important;
        // position:
    }
    @media screen and (max-width:1460px) {
        .path-chart .chart {
            width:100%!important;
            float:none!important;
            text-align:center;
        }
        .path-chart .chart-canvas {
           // transform:none;
           // width:100%!important;
           float:none;
           margin:0 auto;

        }
        .path-chart .legend {
            transform:translateY(70px);
            padding-bottom:70px;
            text-align:center;
            ul {
                display:inline-block;
                text-align:left;
            }
        }
    }
    .path-chart canvas {
        // width:220px!important;
        // height:250px!important;
        margin-left:1rem;
    }
    .path-chart .legend {
        white-space: nowrap;
        overflow:hidden;
    }
    .path-chart .legend span {
        width:10px;
        height:10px; 
        margin-right:1rem;

        display:inline-block;
    }

</style>


// WEBPACK FOOTER //
// Pie.vue?2f794f5e